import React from "react";
import Layout, { LAYOUT_QUERY } from "@/components/Layout";

import { Typography } from "antd";

const { Title } = Typography;

import { RootState } from "@/store/store";
import { RADIO_STATE } from "@/store/liveRadio/action";
import { connect, ConnectedProps } from "react-redux";
import { compose } from "redux";
import { fetchAPI } from "@/utils/api/api";
import NicePage from "@/components/NicePage";

import ScheduleSelector from "@/components/Schedule/ScheduleSelector";
import { GetStaticPropsResult } from "next";
import Schedule from "@/components/Schedule/Schedule";

const SCHEDULE_PAGE_QUERY = `
query GetSchedulePage {
	${LAYOUT_QUERY}
}
`;

const mapState = (state: RootState) => ({
  playing: state.liveRadio.state === RADIO_STATE.PLAYING,
});

const connector = connect(mapState);

type PropsFromRedux = ConnectedProps<typeof connector>;

type StaticProps = { graphQLData: Record<string, unknown> };

type Props = PropsFromRedux & StaticProps;

const SchedulePage = ({ graphQLData }: Props) => {
  return (
    <Layout title="Schedule" data={graphQLData}>
      <ScheduleSelector/>
    </Layout>
  );
};

export async function getStaticProps(): Promise<
  GetStaticPropsResult<StaticProps>
> {
  const data = await fetchAPI(SCHEDULE_PAGE_QUERY);
  return {
    props: {
      graphQLData: data as Record<string, unknown>,
    },
    revalidate: 1,
  };
}

export default compose(connector)(SchedulePage);
